import { render, staticRenderFns } from "./ZDMFailureDictionaryList.vue?vue&type=template&id=fc58d53a&scoped=true&"
import script from "./ZDMFailureDictionaryList.vue?vue&type=script&lang=js&"
export * from "./ZDMFailureDictionaryList.vue?vue&type=script&lang=js&"
import style0 from "./ZDMFailureDictionaryList.vue?vue&type=style&index=0&id=fc58d53a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc58d53a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
